import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { ConvertService } from 'src/app/services/convert.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { DataService } from 'src/app/services/data.service';
import { FireValidatorsService } from 'src/app/services/fire-validators.service';
import { ILevel } from 'src/app/interfaces/resource';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { COLLECTION_NAME } from 'src/app/dummy/app';

@Component({
  selector: 'app-level-form',
  templateUrl: './level-form.component.html',
  styleUrls: ['./level-form.component.scss']
})
export class LevelFormComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  ITEM_KEY: any;
  ITEM: any;
  TITLE: any = "Add new level"

  form: FormGroup;
  name: AbstractControl;
  description: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthStore,
    public store: ResourceStore,
    public ds: DataService,
    private snackBar: MatSnackBar

  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required, FireValidatorsService.checkExistByCompany(this.ds.firestoreRef(), this.auth.selectedCompanyKey, COLLECTION_NAME.LEVEL, "name")],
      description: [null],
      order: [null, Validators.required],
    })
    this.form.disable();
    this.route.params.subscribe(param => {
      const { id } = param;
      if (id !== 'draft') {
        this.ITEM_KEY = param.id;
        this.store.fetchSelectedData(COLLECTION_NAME.LEVEL, this.ITEM_KEY, (doc: ILevel) => {
          if (doc) {
            this.TITLE = "Edit level"
            this.ITEM = doc;
            this.form = this.fb.group({
              name: [null, Validators.required, FireValidatorsService.checkExistByCompany(this.ds.firestoreRef(), this.auth.selectedCompanyKey, COLLECTION_NAME.LEVEL, "name", this.ITEM.name)],
              description: [null],
              order: [null, Validators.required]
            })
            const { name, description, order } = doc;
            this.form.patchValue({
              name, description, order
            })
            this.form.enable();
            this.inputEl.nativeElement.focus();
            return;
          }
          else {
            this.ITEM = null;
            this.router.navigate([`/levels`])
          }
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
        this.form.enable();
      }
    })
  }

  onSave(f: any, isDraft: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    if (this.form.valid) {
      this.form.disable();
      const { name, description, order } = f;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = isDraft ? STATUS_OBJECT.submitted : STATUS_OBJECT.submitted;
      const item: ILevel = {
        key: this.ITEM ? this.ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name.trim()}`),
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name.trim(),
        description,
        order
      }
      this.store.addItem(COLLECTION_NAME.LEVEL, item, (success, res) => {

        if (success) {
          this.snackBar.open("Level has been saved successful.", "Done", { duration: 2500 });
          this.form.reset();
          if (this.ITEM_KEY) {
            const status = isDraft ? 'submitted' : 'submitted'
            this.router.navigate([isDraft ? `/levels/level-form/draft` : `/levels/${status}`])
          }
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
      })
    }
    else {
      this.inputEl.nativeElement.focus();
      this.processNew = false;
      this.processClose = false;
    }
  }

  goBack() {
    this.router.navigate(['/levels'])
  }

}
